<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="10px" fxFlex>

  <div fxLayoutAlign="center center" *ngIf="innerHeigth > 350">
    <i class="fas fa-exclamation-circle warn-ico" [ngStyle]="{'font-size': '5em'}">
    </i>
  </div>

  <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
    <span class="mat-title">{{'noactivatepayment'|translate}}</span>
    <span class="mat-subheading-1">{{'contactwithmerchant'|translate}}</span>
  </div>

</div>
